import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.custom.pageBackground,
    // Makes native scrollbars / form controls follow the active theme.
    colorScheme: theme.palette.type,
    '& .MuiPaper-root': {
      elevation: 3,
    },
  },
  title: {
    fontSize: '19px',
    margin: '10px',
    marginTop: '30px',
    fontWeight: 600,
    color: theme.palette.primary.mainBlue,
  },
  uploadFile: {
    display: 'flex',
    height: '40px',
    width: '160px',
    backgroundColor: theme.palette.custom.solidButtonBackground,
    color: theme.palette.custom.solidButtonText,
    borderRadius: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    '& svg': {
      color: theme.palette.custom.solidButtonText,
    },
  },
  headerContainer: {
    margin: '10px 15px 20px',
    '& button': {
      color: theme.palette.secondary.blue,
      border: `1px solid ${theme.palette.secondary.blue}`,
    },
  },
  disabled: {
    backgroundColor: theme.palette.secondary.gray,
    cursor: 'default',
  },
  messageError: {
    color: theme.palette.secondary.red,
  },
}));

export default useStyles;
